<!-- param: viewMode-控制显示，id-控制数据加载，mode-控制button加载 -->
<template>
  <el-container v-loading="loading">
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <el-button class="ik-list-menu-btn" size="medium" @click="listCreateBtn">新增</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listUpdateBtn">修改</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listDetailsBtn">详情</el-button>
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoCreateBtn">新增</el-button>
          <el-button v-if="mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoUpdateBtn">修改</el-button>
          <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoCopyBtn">复制</el-button>
          <el-button v-if="mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoDetailsBtn">详情</el-button>
          <el-button v-if="mode == 'add' || mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoSaveBtn">保存</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>

      <el-main>
        <!-- 表头 - 信息页 -->
        <el-form
          v-if="viewMode == 'info'"
          id="ik-info-head"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
          @validate="validate"
        >
          <el-row>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_code'"
                v-model="data.head['code']"
                code="code"
                name="编码"
                default-value=""
                :edit="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_name'"
                v-model="data.head['name']"
                code="name"
                name="名称"
                default-value=""
                :edit="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_contactPhone'"
                v-model="data.head['contactPhone']"
                code="contactPhone"
                name="电话"
                default-value=""
                :edit="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_idcardCode'"
                v-model="data.head['idcardCode']"
                code="idcardCode"
                name="身份证号"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_sexSign'"
                v-model="data.head['sexSign']"
                code="sexSign"
                name="性别"
                :options="[{ key: '1', value: '男' }, { key: '2', value: '女' }]"
                default-value="1"
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-date
                :ref="'input_birthDate'"
                v-model="data.head['birthDate']"
                code="birthDate"
                name="出生日期"
                default-value=""
                :edit="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_cardCode'"
                v-model="data.head['cardCode']"
                code="cardCode"
                name="就诊卡号"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_bloodTypeSign'"
                v-model="data.head['bloodTypeSign']"
                code="bloodTypeSign"
                name="血型标识"
                :options="[
                  { key: '1', value: 'A' },
                  { key: '2', value: 'B' },
                  { key: '3', value: 'AB' },
                  { key: '4', value: 'O' }
                ]"
                default-value="1"
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_contactAddress'"
                v-model="data.head['contactAddress']"
                code="contactAddress"
                name="联系地址"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_userCode'"
                v-model="data.head['userCode']"
                url="base/user/user/user/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="userCode"
                name="用户编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_userName'"
                v-model="data.head['userName']"
                code="userName"
                name="用户名称"
                default-value=""
                :edit="false"
                disabled
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
        </el-form>

        <!-- 查询区 - 列表页 -->
        <div v-if="viewMode == 'list'" class="querybg">
          <el-collapse
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <el-form
                id="ik-info-head"
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_code'"
                      v-model="searcher['code']"
                      code="code"
                      name="编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_name'"
                      v-model="searcher['name']"
                      code="name"
                      name="名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_contactPhone'"
                      v-model="searcher['contactPhone']"
                      code="contactPhone"
                      name="电话"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_sexSign'"
                      v-model="searcher['sexSign']"
                      code="sexSign"
                      name="性别"
                      :options="[{ key: '1', value: '男' }, { key: '2', value: '女' }]"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-date
                      :ref="'input_minBirthDate'"
                      v-model="searcher['minBirthDate']"
                      code="minBirthDate"
                      name="生日起始范围"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-date
                      :ref="'input_maxBirthDate'"
                      v-model="searcher['maxBirthDate']"
                      code="maxBirthDate"
                      name="生日结束范围"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_bloodTypeSign'"
                      v-model="searcher['bloodTypeSign']"
                      code="bloodTypeSign"
                      name="血型标识"
                      :options="[
                        { key: '1', value: 'A' },
                        { key: '2', value: 'B' },
                        { key: '3', value: 'AB' },
                        { key: '4', value: 'O' }
                      ]"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <!-- 数据表 - 列表页 -->
        <el-table
          v-if="viewMode == 'list'"
          ref="table"
          v-loading="listLoading"
          :data="tableData"
          element-loading-text="加载中..."
          :stripe="true"
          :border="true"
          :fit="true"
          class="ik-list-table"
          height="calc(100% - 50px)"
          :header-row-class-name="'ik-list-table-header-row'"
          :header-cell-class-name="'ik-list-table-header-cell'"
          :row-class-name="'ik-list-table-body-row'"
          :cell-class-name="'ik-list-table-body-cell'"
          :highlight-current-row="true"
          @row-click="rowClick"
        >
          <ik-column-text code="code" name="编码" :edit="false" />
          <ik-column-text code="name" name="名称" :edit="false" />
          <ik-column-text code="contactPhone" name="电话" :edit="false" />
          <ik-column-text code="idcardCode" name="身份证号" :edit="false" />
          <ik-column-select
            code="sexSign"
            name="性别"
            :edit="false"
            :options="[{ key: '1', value: '男' }, { key: '2', value: '女' }]"
          />
          <ik-column-date code="birthDate" name="出生日期" :edit="false" />
          <ik-column-text code="cardCode" name="就诊卡号" :edit="false" />
          <ik-column-select
            code="bloodTypeSign"
            name="血型标识"
            :edit="false"
            :options="[
              { key: '1', value: 'A' },
              { key: '2', value: 'B' },
              { key: '3', value: 'AB' },
              { key: '4', value: 'O' }
            ]"
          />
          <ik-column-text code="contactAddress" name="联系地址" :edit="false" />
          <ik-column-text code="userCode" name="用户编码" :edit="false" />
          <ik-column-text code="userName" name="用户名称" :edit="false" />
        </el-table>
      </el-main>

      <!-- 分页组件 -->
      <el-footer height="40px">
        <ik-pagination
          v-if="viewMode == 'list'"
          ref="ik_list_pagination"
          :page-no="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total-count="pagination.totalCount"
          @pageChangeMethod="pageChange"
        />
        <el-row v-else class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
// 表单组件
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormDate from '@/components/ik/form/input/IkFormDate'
import IkFormSelect from '@/components/ik/form/input/IkFormSelect'
import IkFormDataPopup from '@/components/ik/form/input/IkFormDataPopup'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkColumnSelect from '@/components/ik/table/ikColumn/IkColumnSelect'
import IkColumnDate from '@/components/ik/table/ikColumn/IkColumnDate'
import IkPagination from '@/components/ik/pagination/IkPagination'
import store from '@/store'
import { getById, findPage, save, update, remove } from '@/api/ik/data/dataApi'

export default {
  components: {
    IkFormText,
    IkFormDate,
    IkFormSelect,
    IkFormDataPopup,
    IkColumnText,
    IkColumnSelect,
    IkColumnDate,
    IkPagination
  },
  data() {
    return {
      // 权限字段
      storeId: store.getters['user/getStoreId'],
      storeCode: store.getters['user/getStoreCode'],

      // 后台接口路径
      bgPath: 'clinic/treatment/patient/patient',
      // Web路径
      webPath: 'health/patient',

      // 界面模式
      viewMode: '',
      // 编辑模式
      mode: '',

      // 加载标识
      loading: false,
      listLoading: false,

      // 查询器是否激活
      searcherActive: "0",
      searcher: {},

      // 列表数据
      tableData: [],
      // 当前选中行
      activeRow: {},

      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0
      },

      // 当前数据
      data: {
        head: {}
      },

      // 验证器
      verify: {
        head: {}
      }
    }
  },
  created() {
    // 获取视图模式
    this.viewMode = this.$route.params.viewMode || "list"
    this.mode = this.$route.params.mode || "list"
    const id = this.$route.query.id || 0

    // 初始化界面
    if (this.mode === "list") {
      this.viewMode = "list"
    } else {
      this.viewMode = "info"
    }

    // 列表页进入时的处理
    if (this.viewMode === "list") {
      this.find()
    } else if (this.viewMode === "info") {
      if (id !== 0) {
        this.get(id)
      } else {
        // 新增模式，初始化默认值
        this.data.head = {
          sexSign: '1',
          bloodTypeSign: '1'
        }
      }
    }
  },
  methods: {
    // ===== 工具栏按钮 =====
    listCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },

    listUpdateBtn() {
      if (this.activeRow.id === undefined) {
        this.$message({ type: 'warning', message: '请选择需要编辑的行!' })
      } else {
        this.$router.push({
          path: '/business/' + this.webPath + '/info/edit',
          query: { id: this.activeRow.id }
        })
      }
    },

    listDetailsBtn() {
      if (this.activeRow.id === undefined) {
        this.$message({ type: 'warning', message: '请选择需要查看的行!' })
      } else {
        this.$router.push({
          path: '/business/' + this.webPath + '/info/details',
          query: { id: this.activeRow.id }
        })
      }
    },

    infoCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },

    infoUpdateBtn() {
      this.mode = "edit"
    },

    infoCopyBtn() {
      this.data.head.id = 0
      this.data.head.code = ''
      this.mode = "edit"
    },

    infoDetailsBtn() {
      this.mode = "details"
      this.get(this.data.head.id)
    },

    infoSaveBtn() {
      this.saveOrUpdate()
    },

    infoCancelBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/list/list' })
    },

    searchBtn() {
      this.pagination.pageNo = 1
      this.find()
    },

    resetBtn() {
      this.searcher = {}
      this.find()
    },

    // ===== 表格操作 =====
    rowClick(row, column, event) {
      this.activeRow = row
    },

    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head-' + fieldName] = errorSign
    },

    pageChange(pageNo, pageSize) {
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      this.find()
    },

    headPopupClick(code, row) {
      if (code === "userCode") {
        this.data.head["userId"] = row.id
        this.data.head["userCode"] = row.code
        this.data.head["userName"] = row.name
      }
    },

    // ===== 接口通讯 =====
    saveOrUpdate() {
      // 验证
      for (const key in this.verify.head) {
        if (this.verify.head[key]) {
          this.$message({ type: 'error', message: '数据格式异常，请检查必填项' })
          return
        }
      }

      // 赋值门店信息
      this.data.head.storeId = this.storeId
      this.data.head.storeCode = this.storeCode

      const $this = this
      if (this.data.head.id) {
        update(this.bgPath, this.data).then(response => {
          $this.id = response.data
          $this.get(response.data)
          $this.$message({ type: 'success', message: '数据已保存!' })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      } else {
        save(this.bgPath, this.data).then(response => {
          $this.id = response.data
          $this.get(response.data)
          $this.$message({ type: 'success', message: '数据已保存!' })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      }
    },

    delete(id) {
      const $this = this
      remove(this.bgPath, id).then(() => {
        $this.$message({ type: 'warning', message: '数据已删除!' })
        $this.find()
      })
    },

    get(id) {
      const $this = this
      getById(this.bgPath, id).then(response => {
        $this.data = response.data
      })
    },

    find() {
      this.listLoading = true
      this.searcher.storeCode = this.storeCode

      findPage(this.bgPath, this.searcher, this.pagination.pageSize, this.pagination.pageNo)
        .then(response => {
          this.tableData = response.data.list
          this.pagination.totalCount = response.data.totalCount
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },

    listDeleteBtn() {
      if (this.activeRow.id === undefined) {
        this.$message({ type: 'warning', message: '请选择需要删除的行!' })
      } else {
        this.$confirm('删除ID为' + this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete(this.activeRow.id)
        }).catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
@import "~@/styles/listinfo.scss";
</style>
